"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOptions = void 0;
var ChartColors_1 = require("../ChartColors");
var utils_1 = require("../utils");
var buildOptions = function (seriesMapArr, theme, options) {
    var seriesArr = [];
    var index = 0;
    for (var series in seriesMapArr) {
        var seriesObj = {
            name: series,
            data: seriesMapArr[series].data,
            yAxis: seriesMapArr[series].yAxis,
            dataLabels: {
                enabled: seriesMapArr[series].showDataLabel,
            },
            color: seriesMapArr[series].color ? seriesMapArr[series].color : ChartColors_1.categoricalColorsArray[index],
            marker: {
                symbol: seriesMapArr[series].markerSymbol,
            },
        };
        seriesArr.push(seriesObj);
        index++;
    }
    var optionsMap = {
        chart: {
            type: options.type ? options.type : 'spline',
        },
        plotOptions: {
            line: {
                marker: {
                    enabled: options.showMarker,
                },
            },
            spline: {
                marker: {
                    enabled: options.showMarker,
                },
            },
        },
        series: seriesArr,
        tooltip: __assign(__assign({}, utils_1.tooltipOptions), { useHTML: true, formatter: options.tooltipFormatter
                ? options.tooltipFormatter
                : function () {
                    return utils_1.SharedChartTooltipFormatterFn(new Date(this.x).toDateString(), utils_1.getTooltipRow.call(this), '');
                } }),
        xAxis: {
            type: options.xAxisType || 'linear',
        },
    };
    return optionsMap;
};
exports.buildOptions = buildOptions;
